/**
 * MyShop App Microservice
 * MyShop App Tier
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: evelyn.gemila@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* eslint-disable */
import { exists } from "./runtime";
import type { BannerInfo } from "./BannerInfo";
import { BannerInfoFromJSON, BannerInfoToJSON } from "./BannerInfo";
import type { Contact } from "./Contact";
import { ContactFromJSON, ContactToJSON } from "./Contact";
import type { ProfilePicture } from "./ProfilePicture";
import { ProfilePictureFromJSON, ProfilePictureToJSON } from "./ProfilePicture";
import type { Social } from "./Social";
import { SocialFromJSON, SocialToJSON } from "./Social";

/**
 *
 * @export
 * @interface MyShop
 */
export interface MyShop {
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  shopId?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  sk?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  shopName?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  shopCode?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  shopDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  profileId?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  accountId?: string;
  /**
   *
   * @type {BannerInfo}
   * @memberof MyShop
   */
  bannerInfo?: BannerInfo;
  /**
   *
   * @type {ProfilePicture}
   * @memberof MyShop
   */
  profilePicture?: ProfilePicture;
  /**
   *
   * @type {Array<Contact>}
   * @memberof MyShop
   */
  contactInfo?: Array<Contact>;
  /**
   *
   * @type {Array<Social>}
   * @memberof MyShop
   */
  socialInfo?: Array<Social>;
  /**
   *
   * @type {Array<string>}
   * @memberof MyShop
   */
  featureProducts?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  status?: MyShopStatusEnum;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  version?: number;
  /**
   *
   * @type {boolean}
   * @memberof MyShop
   */
  isCreator?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MyShop
   */
  isFirstTimer?: boolean;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  createdTimeStamp?: string;
  /**
   *
   * @type {string}
   * @memberof MyShop
   */
  updatedTimeStamp?: string;
  /**
   *
   * @type {boolean}
   * @memberof MyShop
   */
  isBlocked?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MyShop
   */
  loginBlocked?: boolean;
}

/**
 * @export
 */
export const MyShopStatusEnum = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
} as const;
export type MyShopStatusEnum =
  (typeof MyShopStatusEnum)[keyof typeof MyShopStatusEnum];

/**
 * Check if a given object implements the MyShop interface.
 */
export function instanceOfMyShop(): boolean {
  const isInstance = true;

  return isInstance;
}

export function MyShopFromJSON(json: MyShop): MyShop {
  return MyShopFromJSONTyped(json);
}

export function MyShopFromJSONTyped(json: MyShop): MyShop {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    shopId: !exists(json, "shopId") ? undefined : json["shopId"],
    sk: !exists(json, "sk") ? undefined : json["sk"],
    shopName: !exists(json, "shopName") ? undefined : json["shopName"],
    shopCode: !exists(json, "shopCode") ? undefined : json["shopCode"],
    shopDescription: !exists(json, "shopDescription")
      ? undefined
      : json["shopDescription"],
    profileId: !exists(json, "profileId") ? undefined : json["profileId"],
    accountId: !exists(json, "accountId") ? undefined : json["accountId"],
    bannerInfo: !exists(json, "bannerInfo")
      ? undefined
      : BannerInfoFromJSON(json["bannerInfo"]),
    profilePicture: !exists(json, "profilePicture")
      ? undefined
      : ProfilePictureFromJSON(json["profilePicture"]),
    contactInfo: !exists(json, "contactInfo")
      ? undefined
      : (json["contactInfo"] as Array<Contact>).map(ContactFromJSON),
    socialInfo: !exists(json, "socialInfo")
      ? undefined
      : (json["socialInfo"] as Array<Social>).map(SocialFromJSON),
    featureProducts: !exists(json, "featureProducts")
      ? undefined
      : json["featureProducts"],
    status: !exists(json, "status") ? undefined : json["status"],
    version: !exists(json, "version") ? undefined : json["version"],
    isCreator: !exists(json, "isCreator") ? undefined : json["isCreator"],
    isFirstTimer: !exists(json, "isFirstTimer")
      ? undefined
      : json["isFirstTimer"],
    createdTimeStamp: !exists(json, "createdTimeStamp")
      ? undefined
      : json["createdTimeStamp"],
    updatedTimeStamp: !exists(json, "updatedTimeStamp")
      ? undefined
      : json["updatedTimeStamp"],
  };
}

export function MyShopToJSON(value?: MyShop | null) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    shopId: value.shopId,
    sk: value.sk,
    shopName: value.shopName,
    shopCode: value.shopCode,
    shopDescription: value.shopDescription,
    profileId: value.profileId,
    accountId: value.accountId,
    bannerInfo: BannerInfoToJSON(value.bannerInfo),
    profilePicture: ProfilePictureToJSON(value.profilePicture),
    contactInfo:
      value.contactInfo === undefined
        ? undefined
        : (value.contactInfo as Array<Contact>).map(ContactToJSON),
    socialInfo:
      value.socialInfo === undefined
        ? undefined
        : (value.socialInfo as Array<Social>).map(SocialToJSON),
    featureProducts: value.featureProducts,
    status: value.status,
    version: value.version,
    isCreator: value.isCreator,
    isFirstTimer: value.isFirstTimer,
    createdTimeStamp: value.createdTimeStamp,
    updatedTimeStamp: value.updatedTimeStamp,
  };
}
